import * as types from "@/type"

export const read = (file: File, tableName: string): Promise<types.UploadFile> => {
	return new Promise((resolve) => {
		const reader = new FileReader()
		reader.addEventListener("load", () => {
			if (typeof reader.result == "string") {
				resolve({ fileName: file.name, data: reader.result, tableName })
			}
		})
		reader.readAsDataURL(file)
	})
}
